module.exports = __webpack_public_path__ + "static/media/male-final.4116818e.svg";